<template>
  <div class="bx-flooding bx-flooding--header">
    <header class="bx-header">
      <div class="bx-grid bx-header__wrapper">
        <slot name="header-logo" />
        <div class="bx-header__navi-wrapper">
          <MenuList :menu="headerData.menu"
                    menu-type="header"
                    menu-context="desktop"
                    :brand="brand" />
        </div>

        <slot name="header-search" />

        <button id="burger"
                ref="burgerButton"
                :class="{
                  'bx-header__burger': true,
                  'bx-header__burger--open': showBurgerMenu
                }"
                :aria-label="`Menü ${showBurgerMenu ? 'schließen' : 'öffnen'}`"
                :aria-expanded="showBurgerMenu"
                aria-haspopup="true"
                aria-controls="aria-control-burger-menu"
                @click="showBurgerMenu = !showBurgerMenu">
          <Icon v-if="showBurgerMenu"
                name="close" />
          <Icon v-else
                name="burger" />
        </button>

        <div v-if="showBurgerMenu"
             class="bx-header__burger-backdrop"
             @click="showBurgerMenu = false" />

        <div id="aria-control-burger-menu"
             ref="burger"
             :class="{
               'bx-header__burger-navi-wrapper': true,
               'bx-header__burger-navi-wrapper--open': showBurgerMenu
             }">
          <div class="bx-header__burger-navi-wrapper__close">
            <button class="bx-header__burger-close-button"
                    aria-label="Menü schließen"
                    aria-controls="aria-control-burger-menu"
                    :aria-expanded="showBurgerMenu"
                    @click="showBurgerMenu = false">
              <Icon name="close" />
            </button>
          </div>

          <MenuGroupHeadline v-if="$slots['header-channel-navigation']"
                             title="Andere Portale" />

          <slot name="header-channel-navigation" />

          <MenuGroupHeadline title="Kategorien" />

          <MenuList :menu="headerData.menu"
                    menu-type="header"
                    menu-context="burger"
                    :brand="brand" />

          <MenuGroupHeadline v-if="$slots['header-user-navi']"
                             data-menu-group-headline="pur-abo"
                             title="PUR Abo" />

          <slot name="header-user-navi" />

          <MenuGroupHeadline :title="`Folge ${rsConfig.actualBrandName}`" />

          <SocialLinks menu-type="header" />
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState } from 'pinia'

import Icon from './shared/Icon.vue'
import { useConfigStore } from '../stores/config'
import MenuList from './menu/MenuList.vue'
import SocialLinks from './shared/SocialLinks.vue'
import MenuGroupHeadline from './menu/MenuGroupHeadline.vue'
import keepTabbingFocus from '../mixins/keepTabbingFocus.js'

export default {
  components: {
    MenuList,
    Icon,
    SocialLinks,
    MenuGroupHeadline
  },
  mixins: [keepTabbingFocus],
  props: {
    headerData: {
      type: Object,
      default: () => { return {} }
    },
    brand: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      showBurgerMenu: false
    }
  },
  computed: {
    ...mapState(useConfigStore, ['rsConfig'])
  },
  watch: {
    showBurgerMenu (newValue) {
      if (newValue) {
        document.body.classList.add('bx-js-dialog-opened')
        this.keepTabbingFocusInBurger()
      } else {
        document.body.classList.remove('bx-js-dialog-opened')
      }
    }
  },
  methods: {
    keepTabbingFocusInBurger () {
      this.$nextTick(() => {
        this.removeTabbingEventListeners()
        this.keepTabbingFocus(this.$refs.burger, ['a, button:not(.bx-header__burger-close-button)'], 0, () => {
          this.removeTabbingEventListeners()
          this.showBurgerMenu = false
          this.$refs.burgerButton.focus()
        })
      })
    }
  }
}

</script>
